// extracted by mini-css-extract-plugin
export default {"headerBackground":"Auth_headerBackground__t3Eq6","overlay":"Auth_overlay__OrxrJ","headerContent":"Auth_headerContent__HdrkR","headerOverlay":"Auth_headerOverlay__ElQLx"};